angular.module('TurneroApp').component('coPuestosModificar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
    },
    controller: [
        'puestosService',
        'utilsService',
        'TurneroAppConstant',
        function (puestosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.puestoEditar = {};

            ctrl.errores = {
                N_Puesto: false,
                Orden: false
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    ctrl.errores = {
                        N_Puesto: false,
                        Orden: false
                    };

                    if (item && item.Id_Puesto && ctrl.centroAtencionSeleccionado.id) {
                        puestosService.getInfo({
                            'id_Puesto': item.Id_Puesto,
                            'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                        }, function (data) {
                            ctrl.puestoEditar = data;
                        }, function (error) {
                            utilsService.errores(error);
                        });
                    }
                }
            }

            ctrl.guardarPuestoEditado = function () {
                ctrl.puestoEditar.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id;
                ctrl.errores.N_Puesto = !(ctrl.puestoEditar.N_Puesto);
                ctrl.errores.Orden = !(ctrl.puestoEditar.Orden);

                if (ctrl.errores.N_Puesto || ctrl.errores.Orden) {
                    return;
                }

                ctrl.puestoEditar.$update(function (data) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Modificar Puesto", "El puesto se modificó correctamente", "success");
                }, function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./puestosModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/puestos/puestosModificarComponent.js